import { GlobalStyle } from "./style";

export const numCol: number = 18
export const caseMark: string = "case1"
// export const caseMark: string = "case2"


// ===== mainview: glyph style =====
// // move to uiReducer > `mainviewGraphDivSize`
// export const svgSize: { [chartName: string]: GlobalStyle.SVGSize } = {
//   mainview: {
//     width: 1170 - 16 * 2,
//     height: 840,
//     margin: 0,
//   },
// }
// // move to uiReducer > `glyphStyle`
// export const glyphStyle = {
//   svgR: 0, // svgSize.mainview.height / 2,
//   grantGlyphGroupR: 0, // 180, // grant type node整个大小
//   glyphMaxR: 0, // 60, // temp, unified glyph size. TODO: scale the group with total_impact
//   nodePadding: 0, // 5,
//   glyphRRangeRatio: { min: 0.4, max: 1 },
//   minR_Ratio: { directImpact: 0.2, indirectImpact: 0.5, },
//   RDifference_Ratio: { directImpact: 0.3, indirectImpact: 0.5, },  // value范围在[minR_Ratio, minR_Ratio + RDifference_Ratio]之间
//   collideStrength: 1,
// }
// // move to uiReducer > `grantTypeNodeTransformXY`
// export const grantTypeNodeTransformXY ={
//   x: svgSize.mainview.width / 2, // 440,
//   y: svgSize.mainview.height / 2, // 320
// }
// // export const glyphStyle = {
// //   grantGlyphGroupR: 150, // grant type node整个大小
// //   glyphMaxR: 30, // temp, unified glyph size. TODO: scale the group with total_impact
// //   nodePadding: 5,
// //   glyphRRangeRatio: { min: 0.3, max: 1 },
// //   minR_Ratio: { directImpact: 0.2, indirectImpact: 0.5, },
// //   RDifference_Ratio: { directImpact: 0.3, indirectImpact: 0.5, },  // value范围在[minR_Ratio, minR_Ratio + RDifference_Ratio]之间
// //   collideStrength: 1,
// // }
export const mainviewNodeSizeScale = {
  minR: 2,
  maxR: 10,
}



// ===== global setting =====
export const themeColor: { [theme: string]: { [elementName: string]: any } } = {
  defaultMode: {
    colorPrimary: '#7F5539',
    baseColor: '#98ACC0',
    femaleColor: '#CC6594',
    maleColor: '#347DC1',
    piCardColorSubInstituion: '#B08968', // '#347DC1',
    piCardColorNotSubInstituion: '#AE7BAC', // '#CC6594',
    // timelineColorSmall: '#17becf',
    // timelineColorLarge: '#d62728',
    timelineColorSmall: 'white',
    timelineColorLarge: 'black',
    barChartHighlightColor: 'darkorange',


    barChartBarColor: '#AB9587',
    // barChartBarColor: '#B08968',
    barChartBarHighlight: '#87ab95',


    areaChartLineColor: 'black',
    selectionColor: {
      highlight: '#d8b9864a', // '#98ACC066',
      default: 'black',
      defaultCard: '#dad7cd',
      // highlight: '#f8e0b066',
      // default: 'white',
      // defaultCard: '#E9E9E9',
    },
    mainviewColor: {
      fieldTypeGraph: {
        node: {
          default: '#a3b18a', // #5d8485， #688fb0 （highlight node）
          highlight: '#588157',
        },
        link: {
          default: '#a3b18a',
          highlight: '#588157',
        },
      },
    }
  },
  darkMode: {},

};

export const viewSize: { [attrName: string]: GlobalStyle.ViewSize } = {
  systemSize: {
    width: '95vw', // 响应式宽度
    height: '100vh',
    margin: '0 auto',
    padding: 0,
  },
  queryView: {
    width: '20vw',
    height: '55vh',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  queryViewFolded: {
    width: '20vw',
    height: 45,
    margin: 4,
    padding: 4,
  },
  // queryViewFolded: {
  //   width: '20vw',
  //   height: '4vh',
  //   margin: '4',
  //   padding: '4',
  //   // margin: '0.5rem',
  //   // padding: '0.5rem',
  // },
  grantView: {
    width: '20vw',
    height: 'calc(20vw + 36px)',
    // height: '30vh',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  PIView: {
    width: '20vw',
    height: 'calc(100vh - 30vh - 45px - 8px - 45px)', // - 45px - 4 * 4px,  '40vh',
    margin: '0.5rem',
    padding: '0.5rem',
  },
  impactStatisticsView: {
    width: '20vw',
    height: 'calc((100vh - 45px - 8px) / 2)',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  impactEntityView: {
    width: '20vw',
    height: 'calc((100vh - 45px - 8px) / 2)',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  mainView: {
    width: 'calc(60vw - 0px)',
    height: 'calc(100vh - 45px - 8px - 4px)',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  mainviewImpactSummary: {
    width: '58vw',
    height: '8vh', // not used
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
  mainviewGraphDiv: {
    width: '58vw',
    height: '0',
    margin: '4',
    padding: '4',
  },
  PIStatisticsViewCard: {
    width: '17vw',
    height: 215,
    margin: 20,
    padding: 4,
  },
  // PIStatisticsViewCard: {
  //   width: '16vw',
  //   height: '20vh',
  //   margin: '4',
  //   padding: '4',
  //   // margin: '1rem',
  //   // padding: '0.5rem',
  // },
  PIStatisticsViewCardList: {
    width: '17vw',
    height: '40vh',
    margin: '4',
    padding: '4',
    // margin: '0.5rem',
    // padding: '0.5rem',
  },
};

// export const viewSize: { [attrName: string]: GlobalStyle.ViewSize } = {
//   systemSize: {
//     width: 1920,
//     height: 1080,
//     margin: 0,
//     padding: 0,
//   },
//   queryView: {
//     width: 360,
//     height: 460, // 540,
//     margin: 4,
//     padding: 4,
//   },
//   queryViewFolded: {
//     width: 360,
//     height: 45,
//     margin: 4,
//     padding: 4,
//   },
//   grantView: {
//     width: 360,
//     height: 360,
//     margin: 4,
//     padding: 4,
//   },
//   PIView: {
//     width: 360,
//     height: 604,
//     margin: 4,
//     padding: 4,
//   },
//   impactStatisticsView: {
//     width: 360,
//     height: 360,
//     margin: 4,
//     padding: 4,
//   },
//   impactEntityView: {
//     width: 360,
//     height: 651,
//     margin: 4,
//     padding: 4,
//   },
//   mainView: {
//     width: 1170,
//     height: 1016,
//     margin: 4,
//     padding: 4,
//   },
//   mainviewImpactSummary: {
//     width: 1142,
//     height: 112,
//     margin: 4,
//     padding: 4,
//   },
//   PIStatisticsViewCard: {
//     width: 322,
//     height: 215,
//     margin: 20,
//     padding: 4,
//   },
//   PIStatisticsViewCardList: {
//     width: 340,
//     height: 550,
//     margin: 4,
//     padding: 4,
//   },
// };

export const panelStyle: GlobalStyle.PanelStyle = {
  panelHeaderHeight: 36,
  margin: 4,
  padding: 0,
};


// ===== Common Components Style =====
export const commonComponentsStyle = {
  SubTitle: {
    background: 'linear-gradient(to left, rgba(181, 194, 210, 0.3), rgba(181, 194, 210, 0))',
    justifyContent: 'flex-end',
    textMargin: '0 10px 0 0',
    backgroundColor: '',
  },
}

// ===== Visualization Style =====
export const visualizationStyle: { [chartName: string]: { [attrName: string]: any } } = {
  Scatterplot: {
    grantFieldColorMap: {
      "Creative Arts And Writing":'#e9c46a',
      "Human Society": '#e9c46a',
      "History, Heritage And Archaeology": '#e9c46a',
      "Language, Communication And Culture": '#e9c46a',
      "Philosophy And Religious Studies": '#e9c46a',

      "Education": '#f4a261',
      "Law And Legal Studies": '#f4a261',
      "Economics": '#f4a261',
      "Commerce, Management, Tourism And Services": '#f4a261',

      "Psychology":  '#e76f51',
      "Mathematical Sciences": '#e76f51',
      "Physical Sciences": '#e76f51',

      "Built Environment And Design": '#2a9d8f',
      "Agricultural, Veterinary And Food Sciences": '#2a9d8f',
      "Earth Sciences": '#2a9d8f',
      "Environmental Sciences": '#2a9d8f',

      "Health Sciences": '#336699',
      "Biological Sciences": '#1d3557',
      "Biomedical And Clinical Sciences": '#5f797bff',

      "Chemical Sciences":'#1d3557',

      "Engineering": '#4a6fa5',
      "Information And Computing Sciences": '#4a6fa5',
    },
  },
  Wordle: {
    wordSize: 250,
    fontSizeRange: [12, 36],
    padding: 6,
  },
}

// ===== Grant View: style =====
export const grantViewStyle = {
  scatterplot: {
    margin: 16,
    // width: 320,
    // height: 290,
  },
  barChart: {
    width: 324,
    height: 60,
    labelHeight: 20,
    labelMarginBottom: 8,
    // heightWithLabel: 60 + 20 + 8, // 60: bar chart height, 20: label height, 8: margin bottom
  },
  timeline: {
    width: 324,
    height: 60,
  },
}

// ===== PI View style =====
export const piViewStyle = {
  colorMapGender: {
    Female: '#92b9bd',
    Male: '#967d69',
  },
  colorMapCareerAge: {
    Senior: '#504631',
    Middle: '#967d69',
    Junior: '#caccc5'
  },
  barChart: {
    width: 324,
    height: 60,
    labelHeight: 20,
    labelMarginBottom: 8,
    // heightWithLabel: 60 + 20 + 8, // 60: bar chart height, 20: label height, 8: margin bottom
  },
  areaChart: {
    width: 324,
    height: 66,
    labelHeight: 20,
    labelMarginBottom: 8,
    // heightWithLabel: 66 + 20 + 8, // 66: area chart height, 20: label height, 8: margin bottom
  },
}

// ===== Impact Statistics View style =====
export const impactStatisticsViewStyle = {
  areaChart: {
    // width: 330,
    height: 60,
  },
}

// ===== Impact Entity View style =====
export const impactEntityViewStyle = {
  barChart: {
    // width: 324,
    height: 60,
    labelHeight: 20,
    labelMarginBottom: 8,
    // heightWithLabel: 60 + 20 + 8, // 60: bar chart height, 20: label height, 8: margin bottom
  },
}


